var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgMenuContract = function SvgMenuContract(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "MCT_1_",
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "MCT_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MCT_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MCT_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M24.579,35.5 H10.483c-1.096,0-1.984-0.889-1.984-1.984V6.483c0-1.095,0.888-1.984,1.984-1.984H26.5l5.001,4.021v15.228"
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#MCT_2_)",
    fill: "none",
    stroke: "#00C752",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 12.882,
    y1: 12.517,
    x2: 27.117,
    y2: 12.517
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#MCT_2_)",
    fill: "none",
    stroke: "#00C752",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 12.882,
    y1: 15.509,
    x2: 27.117,
    y2: 15.509
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#MCT_2_)",
    fill: "none",
    stroke: "#00C752",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 12.882,
    y1: 18.501,
    x2: 27.117,
    y2: 18.501
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#MCT_2_)",
    fill: "none",
    stroke: "#00C752",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 12.882,
    y1: 21.493,
    x2: 22.125,
    y2: 21.493
  }), /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#MCT_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 28.674,
    cy: 30.005,
    r: 6.832
  }), /*#__PURE__*/React.createElement("polyline", {
    clipPath: "url(#MCT_2_)",
    fill: "none",
    stroke: "#00C752",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    points: " 24.435,29.826 27.188,32.809 32.596,27.348  "
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuContract, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-contract.c84191e3.svg";
export { ForwardRef as ReactComponent };